export enum ShippingZoneType {
  Continent = 'continent',
  Country = 'country',
}
